import { LowerCasePipe } from '@angular/common';
import { Directive, ElementRef, Input, OnInit, Renderer2, inject } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[porAddFeature]'
})
export class AddFeatureClassDirective implements OnInit {
    private readonly renderer = inject(Renderer2);
    private readonly hostElement = inject(ElementRef);
    private readonly lower = inject(LowerCasePipe);

    @Input() featureName!: string;

    ngOnInit(): void {
        if (this.featureName) {
            this.renderer.setAttribute(this.hostElement.nativeElement, 'data-testid', `por-cp-${this.lower.transform(this.featureName).replace(/ /g, '-')}`);
        }
    }
}
